import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { Link } from "react-router-dom";

export default function PiarcPathwayNav() {
  return (
    <section className="bg-tie-teal/5 py-10 md:py-14">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <div className="flex flex-col md:flex-row items-center justify-between gap-6 p-6 md:p-8 rounded-xl bg-white border border-tie-teal/20">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-tie-teal/10 flex items-center justify-center shrink-0">
                  <i className="ri-links-line text-tie-teal text-xl" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-tie-text-primary">
                    Part of the Research Wing
                  </p>
                  <p className="text-sm text-tie-text-secondary">
                    PIARC feeds into IJTAI publication and AIRCon presentation, creating a complete research pipeline.
                  </p>
                </div>
              </div>
              <div className="flex flex-wrap gap-3">
                <Link
                  to="/ijtai"
                  className="inline-flex items-center px-5 py-2.5 rounded-full bg-tie-grey-light text-tie-text-primary text-sm font-medium hover:bg-tie-teal hover:text-white transition-all duration-300 whitespace-nowrap"
                >
                  <i className="ri-arrow-left-line mr-1.5" />
                  IJTAI
                </Link>
                <Link
                  to="/aircon"
                  className="inline-flex items-center px-5 py-2.5 rounded-full bg-tie-grey-light text-tie-text-primary text-sm font-medium hover:bg-tie-teal hover:text-white transition-all duration-300 whitespace-nowrap"
                >
                  AIRCon
                  <i className="ri-arrow-right-line ml-1.5" />
                </Link>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}